// extracted by mini-css-extract-plugin
export default {"contant":"PriceItim_contant__kinXZ","delprice":"PriceItim_delprice__DabfP"};